// extracted by mini-css-extract-plugin
export default {"main":"Teams_main__XVVSQ","teamOuter":"Teams_teamOuter__P1d8r","teamList":"Teams_teamList__WM9MT"};